import React from "react";

export const Book = () => {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1554_4055)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 23.8542V3.28714C0 2.30329 0.626935 1.41773 1.58371 1.18857C5.93687 0.145925 11.0565 0.449498 14.674 2.19954C14.6726 2.22568 14.6719 2.252 14.6719 2.27849V17.4247C13.4183 19.2662 12.9286 21.4444 12.9286 23.5806C12.9286 24.1664 12.9654 24.7557 13.0448 25.3399C9.59646 24.1842 5.27129 24.0933 1.52379 25.003C0.765735 25.1872 0 24.6341 0 23.8542ZM30.6775 16.1186C31.1982 16.6394 31.6363 17.2031 32 17.7978V3.28714C32 2.30329 31.373 1.41773 30.4162 1.18857C26.1399 0.164332 21.124 0.439199 17.519 2.1082C17.5256 2.16404 17.529 2.22087 17.529 2.27849V14.738C19.2656 13.7047 21.2582 13.2936 23.2155 13.2936C25.883 13.2936 28.6162 14.0572 30.6775 16.1186ZM20.1982 20.5632C19.6346 21.1268 19.2143 22.0671 19.2143 23.5806C19.2143 25.094 19.6346 26.0343 20.1982 26.5977C20.7618 27.1614 21.7021 27.5817 23.2155 27.5817C23.3102 27.5817 23.4025 27.5801 23.4926 27.5769C24.845 27.5287 25.7045 27.1262 26.2327 26.5977C26.3033 26.5273 26.3714 26.451 26.4368 26.3685C26.8949 25.7902 27.2167 24.9047 27.2167 23.5806C27.2167 22.0671 26.7963 21.1268 26.2327 20.5632C25.6693 19.9996 24.7289 19.5793 23.2155 19.5793C21.7021 19.5793 20.7618 19.9996 20.1982 20.5632ZM18.3158 17.6573C19.6364 16.6166 21.3391 16.1507 23.2155 16.1507C23.3495 16.1507 23.4827 16.1531 23.6149 16.1579C25.5975 16.2298 27.3637 16.8454 28.6571 18.1389C28.8297 18.3113 28.9899 18.4922 29.1387 18.6809C30.1794 20.0015 30.6453 21.7041 30.6453 23.5806C30.6453 25.0798 30.3479 26.4679 29.6976 27.6391L31.384 29.3255C32.0535 29.995 32.0535 31.0805 31.384 31.7497C31.0619 32.0718 30.6439 32.2389 30.2222 32.2512C30.0955 32.2549 29.9689 32.2446 29.8441 32.2206C29.52 32.1577 29.2105 32.0009 28.9595 31.7497L27.2729 30.0631C26.1022 30.7132 24.7143 31.0103 23.2155 31.0103C21.071 31.0103 19.1535 30.4018 17.7739 29.0222C16.3942 27.6425 15.7857 25.725 15.7857 23.5806C15.7857 21.436 16.3942 19.5185 17.7739 18.1389C17.9463 17.9664 18.1272 17.806 18.3158 17.6573Z"
          fill="#6C3BC7"
        />
      </g>
      <defs>
        <clipPath id="clip0_1554_4055">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
